import React from 'react';
import Logo from "../svg/Logo";
import "./Overlay.scss";

const Overlay = () => {
    return (
        <div className="overlay" aria-live="assertive">
            <p className="overlay__dots">
                <Logo mainColor="#D0103A" altColor="#2F2F30" underline="#C9CAC8"/>
            </p>
        </div>
    );
};

export default Overlay;